import { signalStore, withState, patchState, withMethods } from "@ngrx/signals";

export interface LoaderState {
  isLoading: boolean;
}

const initialState: LoaderState = {
  isLoading: false
};

export const LoaderStore = signalStore(
  { providedIn: "root" },
  withState(initialState),
  withMethods((store) => ({
    show(): void {
      patchState(store, { isLoading: true });
    },

    hide(): void {
      patchState(store, { isLoading: false });
    }
  }))
);
